import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPedagogo'; 
import AboutNeurologista from './AboutPedagogo';
import CorpoClinico from './CorpoClinico';
import "../../styles/psicomotricidade.css";
import "../../styles/footer.css";

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutNeurologista />
        <CorpoClinico />
      </div>
    );
  };
  
  export default About;